module.exports = __webpack_public_path__ + "img/parceiro8.fdc954b6.png";